import _toConsumableArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.array.find-index.js";
import Vue from 'vue';
export function SET_ARRAY(state, payload) {
  state[payload.state] = _toConsumableArray(payload.data);
}
export function PUSH_ARRAY(state, payload) {
  state[payload.state] = [].concat(_toConsumableArray(state[payload.state]), _toConsumableArray(payload.data));
}
export function SET(state, payload) {
  state[payload.state] = payload.data;
}

/**
 *
 * @param {object} state
 * @param {{state: string, targets: array,  key: string}} payload
 * @constructor
 */
export function REMOVE_FROM_ARRAY(state, payload) {
  payload.targets.forEach(function (target) {
    state[payload.state].splice(state[payload.state].findIndex(function (i) {
      return i[payload.key] === target;
    }), 1);
  });
}
export function INCREMENT_MULTI_DETACH_INDEX(state) {
  Vue.set(state.multiDetach, 'index', state.multiDetach.index + 1);
}